import { attributesToProps } from 'html-react-parser';
import { Image } from '@/app_components/common/Image';
import type { ParserProps } from '@/app_lib/htmlParser/types';
import { cn } from '@/app_lib/utils/utils';
import { allowedDomains } from '@/appsecureConstants';

export const ImageParser = ({ domNode, reactNode }: ParserProps) => {
  const { attribs } = domNode;
  const props = attributesToProps(attribs);
  const { src, className, alt, width, height } = props;
  const dataSrc = attribs['data-src'];

  if (!(src || dataSrc)) {
    return null;
  }

  const newSrc = dataSrc?.toString() || src.toString();

  if (
    allowedDomains.every((domain) => !(newSrc.startsWith(`https://${domain}`) || newSrc.startsWith(`http://${domain}`)))
  ) {
    return reactNode;
  }

  const widthNum = width ? Number(width) : 1024;
  const heightNum = height ? Number(height) : 683;

  return (
    <div className='block w-full'>
      <Image
        alt={alt?.toString() || ''}
        className={cn(className, 'not-prose w-full', !(widthNum && heightNum) && 'object-cover')}
        height={heightNum}
        loading='lazy'
        src={newSrc}
        width={widthNum}
      />
    </div>
  );
};
